const getRentalApplication = state => state.rentalApplication;

export default {
    makeNewInviteStatus(state) {
        return getRentalApplication(state).currentListing.newInviteStatus;
    },
};
